<template>
	<div class="side_navigation">
		<div class="top">
			<i @click="toggleCollapse"></i>
		</div>

		<el-menu :default-active="activeIndex" :collapse="isCollapse" :unique-opened="true" @select="handleSelect">
			<el-submenu index="1">
				<template slot="title">
					<img src="../../../../assets/images/money_icon.png" alt=""
						style="width: 18px;height: 18px;margin-right: 5px;">
					<span slot="title">财务统计</span>
				</template>
				<el-menu-item v-if="authInfo.ucategory != 3" index="1-1">代理商对账</el-menu-item>
				<el-menu-item index="1-2">医院对账</el-menu-item>
				<el-menu-item index="1-3">用户对账</el-menu-item>
			</el-submenu>
			<el-submenu index="2">
				<template slot="title">
					<img src="../../../../assets/images/statistics_icon.png" alt=""
						style="width: 18px;height: 18px;margin-right: 5px;">
					<span slot="title">训练监控</span>
				</template>
				<el-menu-item index="2-1">异常训练监控</el-menu-item>
				<el-menu-item index="2-2">每日训练监控</el-menu-item>
				<el-menu-item index="2-3">带训人数统计</el-menu-item>
				<el-menu-item index="2-4">用户账户查询</el-menu-item>
				<el-menu-item v-if="authInfo.ucategory == 1 || authInfo.ucategory == 2" index="2-5">带训管理查询</el-menu-item>
				<el-menu-item v-if="authInfo.ucategory != 2" index="2-6">备忘录提醒</el-menu-item>
			</el-submenu>
			<!-- <el-submenu v-if="reportShow" index="3">
				<template slot="title">
					<img src="../../../../assets/images/money_icon.png" alt=""
						style="width: 18px;height: 18px;margin-right: 5px;">
					<span slot="title">报表统计</span>
				</template>
				<el-menu-item index="3-1">报表统计</el-menu-item>
			</el-submenu> -->
		</el-menu>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'

	const PATH_LIST = [{
		index: "1-1",
		path: "/index/data_governance/finance_agent"
	}, {
		index: "1-2",
		path: "/index/data_governance/finance_hospital"
	}, {
		index: "1-3",
		path: "/index/data_governance/finance_user"
	}, {
		index: "2-1",
		path: "/index/data_governance/training_abnormal"
	}, {
		index: "2-2",
		path: "/index/data_governance/training_date"
	}, {
		index: "2-3",
		path: "/index/data_governance/training_number"
	}, {
		index: "2-4",
		path: "/index/data_governance/training_account"
	}, {
		index: "2-5",
		path: "/index/data_governance/training_manager"
	}, {
		index: "2-6",
		path: "/index/data_governance/training_memo"
	}, {
		index: "3-1",
		path: "/index/data_governance/report_agent"
	}];
	export default {
		created() {
			this.initActiveIndex();
		},
		data() {
			return {
				isCollapse: true,
				activeIndex: '',
				reportShow:true
			}
		},
		computed: {
			...mapState([
				'authInfo'
			])
		},
		methods: {
			initActiveIndex() {
				const that = this;
				var _path = this.$route.path,
					_category = this.authInfo.ucategory;
				that.activeIndex = '';
				if (_path == PATH_LIST[0].path && _category == 3) {
					that.activeIndex = PATH_LIST[1].index;
					that.$router.replace({
						path: PATH_LIST[1].path
					});
					return false;
				}
				if (_path == PATH_LIST[7].path && _category != 1 && _category != 2) {
					that.activeIndex = PATH_LIST[1].index;
					that.$router.replace({
						path: PATH_LIST[1].path
					});
					return false;
				}
				if (_path == PATH_LIST[8].path && _category == 2) {
					that.activeIndex = PATH_LIST[1].index;
					that.$router.replace({
						path: PATH_LIST[1].path
					});
					return false;
				}
				PATH_LIST.forEach((v) => {
					v.path == _path && (that.activeIndex = v.index);
				});
				if (that.activeIndex)
					that.isCollapse = false;
				else
					that.isCollapse = true;
			},
			handleSelect(key) {
				var _path,
					_currentPath = this.$route.path;
				PATH_LIST.forEach((v) => {
					v.index == key && (_path = v.path);
				});
				_currentPath != _path && this.$router.push({
					path: _path
				});
			},
			toggleCollapse() {
				this.isCollapse = !this.isCollapse;
			}
		},
		watch: {
			$route() {
				this.initActiveIndex();
			}
		}
	}
</script>

<style>
	.data_governance_page .side_navigation {
		display: block;
		position: relative;
		height: 100%;
		background: #f7f7f7;
		overflow-x: hidden;
		overflow-y: auto;
	}

	.data_governance_page .side_navigation:after {
		content: "";
		display: block;
		position: absolute;
		width: 1px;
		height: 100%;
		top: 0;
		right: 0;
		background: #cecece;
	}

	.data_governance_page .side_navigation::-webkit-scrollbar {
		display: none;
	}

	.data_governance_page .side_navigation .top {
		display: block;
		border-bottom: 1px solid rgba(255, 255, 255, .1);
		background: #d9d9d9;
		font-size: 0;
	}

	.data_governance_page .side_navigation .top i {
		display: inline-block;
		width: 64px;
		height: 64px;
		vertical-align: top;
		background-image: url(../../../../assets/images/mini.png);
		cursor: pointer;
	}

	.data_governance_page .side_navigation .el-menu:not(.el-menu--collapse) {
		width: 220px;
	}

	.data_governance_page .side_navigation .el-menu {
		border-right: none;
		background: #dfdfdf;
	}

	.data_governance_page .side_navigation .el-menu--inline {
		background: #d4d4d4;
	}

	.data_governance_page .side_navigation .el-submenu__title {
		color: #333;
	}

	.data_governance_page .side_navigation .el-menu-item {
		color: #666;
	}

	.data_governance_page .side_navigation .el-menu-item.is-active {
		background: #d4d4d4;
		color: #409EFF;
	}

	.data_governance_page .side_navigation .el-submenu__title:hover {
		background: #dfdfdf;
	}

	.data_governance_page .side_navigation .el-menu-item:hover {
		background: #d4d4d4;
	}
</style>